import Login from '../views/authentication/login';
import Modules from "../views/modules/main";

let authRoutes = [
    {path: '/authentication/login', name: 'Login', icon: 'mdi mdi-account-key', component: Login},
    {path: '/modules/main', name: 'Modules', icon: 'mdi mdi-adjust', component: Modules},
];
export default authRoutes; 